module.exports = __webpack_public_path__ + "d23602c39f2c07d41cc3c4f31e628a0b.png";